<template>
  <div class="workspace" v-if="restaurantId">
    <div ref="result"></div>

    <div class="mt-4" v-if="selectedRestaurant && !refreshMap">
      <div class="section-heading">
        <h2>Delivery Zones</h2>
        <a ><div class="tr-button green-button" @click="newZone"><i class="fas fa-plus"></i> Add New Zone</div></a>
      </div>
      <define-boundary :edit="boundary_click" ref="defineMap" :selected="selectedBoundary" :boundaries="boundaries" :saved="saved" v-if="selectedRestaurant && showMap" :restaurant="selectedRestaurant"></define-boundary>

      <div class="delivery-zones-top mt-4 flex">
        <h2>Active Zones</h2> <span @click="$refs.defineMap.fitBounds(null, false)" class="cursor-pointer ml-4" style="padding-top: 4px"><u>All</u></span>
      </div>
      <div v-if="boundaries.length > 0" class="zone-list">
        <div @click="boundary_click(boundary)" v-if="boundaries.length > 0" v-for="boundary in boundaries" :key="boundary.id" >
          <boundary-item  v-if="location" :location="location" :deleted="deleted" :boundary-data="boundary" :restaurant-id="restaurantId" />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="section-heading">
        <h2>Delivery Zones</h2>
      </div>
      <div>Please select a restaurant to proceed</div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import DataViewSidebar from './DataViewSidebar'
import BoundaryItem from './BoundaryItem'
import DefineBoundary from './DefineBoundary'
export default {
  components: {
    vSelect,
    DataViewSidebar,
    DefineBoundary,
    BoundaryItem
  },
  data () {
    return {
      restaurantId: -1,
      isMounted: false,
      isEdit: false,
      hideViews: false,
      isAdd: false,
      location: null,
      selectedBoundary: null,
      refreshMap: false,
      showMap: false,
      name: '',
      price: 0,
      estimatedTime: ''
    }
  },
  computed: {
    boundaries () {
      return this.$store.state.api.boundaries.map(boundary => {
        if (!boundary.color) {
          boundary.color = this.generateRandomColor()
        }
        return boundary
      })
    },

    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  },
  watch: {
    isAdd () {
      if (!this.isAdd) {
        this.clearData()
      }
    },
    refreshMap () {
      if (this.refreshMap) {
        setTimeout(() => {
          this.refreshMap = false
        }, 500)
      }
    },
    '$store.state.api.selectedRestaurant' (val) {
      if (val === '-1') {
        this.hideViews = true
      } else if (val) {
        this.restaurantId = this.selectedRestaurant.id
        this.getRestaurantLocation()
        this.getBoundarylist()
      }
    }
  },
  methods: {
    generateRandomColor () {
      const maxVal = 0xFFFFFF // 16777215
      let randomNumber = Math.random() * maxVal
      randomNumber = Math.floor(randomNumber)
      randomNumber = randomNumber.toString(16)
      const randColor = randomNumber.padStart(6, 0)
      return `#${randColor.toUpperCase()}`
    },
    newZone () {
      this.$refs.defineMap.centerMark()
    },
    boundary_click (boundary) {
      this.selectedBoundary = boundary
      this.$refs.defineMap.fitBounds(boundary, true)
      //this.refreshMap = true
      //window.google.maps.event.trigger(this.$refs.defineMap, 'resize')
    },
    saved () {
      this.getBoundarylist()
    },
    deleted () {
      this.getBoundarylist()
    },
    clearData () {

    },
    editData () {
      this.isEdit = true
    },
    deleteData (id) {
      const obj = {
        restaurantId: this.restaurantId,
        boundaryId: id
      }
      this.$store.dispatch('api/removeBoundary', obj).then(() => {
        this.$vs.notify({
          title: 'Delete',
          text: 'Item deleted succesfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        this.getBoundarylist()
      }).catch(err => { console.error(err) })
    },
    addNewData () {
      this.isAdd = !this.isAdd
    },
    saveNewData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            boundaryId: null,
            restaurantId: this.restaurantId,
            boundaryName: this.name,
            price: this.price,
            estimatedTime: this.estimatedTime
          }

          this.$store.dispatch('api/setBoundary', obj)
            .then(() => {
              this.$emit('closeSidebar')
              this.initValues()
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    },
    getBoundarylist () {
      this.showMap = false
      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getBoundaryList', payload)
        .then(() => {
          this.$vs.loading.close()
          setTimeout(() => {
            this.showMap = true
          }, 500)
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    async getRestaurantLocation () {
      this.location = null
      const addressObj = {
        address: this.selectedRestaurant.user_property['Address'],
        country: 'United States'
      }

      //todo replace geocoder with vue meta geocode lib
      this.geocoder.geocode(addressObj, (response, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {

          this.location = {
            lat: response[0].geometry.location.lat(),
            lng: response[0].geometry.location.lng()
          }

        }
      })
    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true

    if (this.selectedRestaurant) {
      this.restaurantId = this.selectedRestaurant.id
      this.getBoundarylist()
    }
    this.geocoder = new window.google.maps.Geocoder(this.$refs.result)
    this.getRestaurantLocation()
  }
}
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0;
        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
